import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, PlugIcon } from 'lucide-react';
import { IMG } from '../../data/images';
import { useCart } from '../../contexts/CartContext';
import { formatPrice } from '../../utils/currency';
import { discountPercent, getProduct } from '../../utils/products';
export function Hero() {
  const {
    addItem
  } = useCart();
  const deal = getProduct('ecoflow-delta-3-plus')!;
  return <section className="mx-auto max-w-7xl px-4 pt-5 sm:px-6 lg:px-8 lg:pt-6" data-id="element-132" data-mp="aq4r0gkaknta">
      <div className="grid gap-4 lg:grid-cols-12 lg:gap-5" data-id="element-133" data-mp="5ofcus1rvu0z">
        <div className="relative overflow-hidden rounded-2xl bg-ink lg:col-span-8" data-id="element-134" data-mp="qdt04wivqog">
          <div className="grid h-full md:grid-cols-2" data-id="element-135" data-mp="s73xwe64x29">
            <div className="relative z-10 flex flex-col justify-center p-7 sm:p-10 lg:p-12" data-id="element-136" data-mp="3rxys4q8dxzmf">
              <p className="text-sm font-semibold text-volt" data-id="element-137" data-mp="1v3c4usxvevdw">Home batteries from €2,149</p>
              <h1 className="mt-3 text-[34px] font-extrabold leading-[1.05] tracking-tight text-white sm:text-[44px]" data-id="element-138" data-mp="1q5250517b6ly">
                Store your solar.
                <br data-id="element-139" data-mp="1myp1hap80xnv" />
                Use it tonight.
              </h1>
              <p className="mt-4 max-w-sm text-[15px] leading-relaxed text-white/70" data-id="element-140" data-mp="1rx0bpmjfha6m">
                Build a home battery sized for your roof in under two minutes. Installed by certified partners across the
                Netherlands and Belgium.
              </p>
              <div className="mt-7 flex flex-wrap gap-3" data-id="element-141" data-mp="25mkayidsvpb6">
                <Link to="/product/ampra-stack" className="inline-flex h-12 items-center gap-2 rounded-lg bg-volt px-5 text-sm font-semibold text-ink transition-colors duration-150 hover:bg-volt-hover" data-id="element-142" data-mp="25p6hqfsva0sc">
                  Build your system
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-143" data-mp="20u0zbqyob490" />
                </Link>
                <Link to="/shop/home-batteries" className="inline-flex h-12 items-center rounded-lg border border-white/25 px-5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-white/10" data-id="element-144" data-mp="2ojlhw8qwzzhr">
                  Compare batteries
                </Link>
              </div>
            </div>
            <div className="relative min-h-[240px] md:min-h-full" data-id="element-145" data-mp="2u6nko23dtv1f">
              <img src={IMG.hero} alt="White home battery and inverter installed on a garage wall" className="absolute inset-0 h-full w-full object-cover" data-id="element-146" data-mp="2p8vubcidygzc" />
            </div>
          </div>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:col-span-4 lg:grid-cols-1 lg:gap-5" data-id="element-147" data-mp="2fiaph7c4cg7z">
          <article className="flex gap-4 rounded-2xl border border-line bg-white p-5" data-id="element-148" data-mp="2ajg889tsuzpz">
            <div className="flex min-w-0 flex-1 flex-col" data-id="element-149" data-mp="26i4g9xnge2em">
              <p className="text-xs font-semibold text-sale" data-id="element-150" data-mp="26jpa1l1y1hbf">Deal of the week · −{discountPercent(deal)}%</p>
              <h2 className="mt-1.5 text-base font-semibold leading-snug text-ink" data-id="element-151" data-mp="21i9o7qrxz6rz">
                <Link to={`/product/${deal.id}`} className="hover:underline" data-id="element-152" data-mp="1wl9kvnmh8i4k">
                  {deal.name}
                </Link>
              </h2>
              <p className="mt-1 text-xs text-muted" data-id="element-153" data-mp="h10ksfyeqrec">{deal.specs.join(' · ')}</p>
              <div className="mt-auto flex items-baseline gap-2 pt-4" data-id="element-154" data-mp="h2tr1u53z9lt">
                <span className="text-2xl font-bold tracking-tight text-ink" data-id="element-155" data-mp="m0lfufagifls">{formatPrice(deal.price)}</span>
                <span className="text-sm text-muted line-through" data-id="element-156" data-mp="q0vx4o3p8sfy">{formatPrice(deal.compareAt!)}</span>
              </div>
              <button type="button" onClick={() => addItem(deal)} className="mt-3 h-10 rounded-lg bg-ink text-sm font-semibold text-white transition-colors duration-150 hover:bg-ink-soft" data-id="element-157" data-mp="3pezcv6i9dsmk">
                Add to cart
              </button>
            </div>
            <Link to={`/product/${deal.id}`} className="w-28 shrink-0 overflow-hidden rounded-xl bg-surface sm:w-32" tabIndex={-1} aria-hidden="true" data-id="element-158" data-mp="36qkpqub2ayr1">
              <img src={deal.image} alt="" className="h-full w-full object-cover" data-id="element-159" data-mp="3aq37jh7l6tpn" />
            </Link>
          </article>

          <Link to="/shop/plug-in" className="group flex flex-col justify-between rounded-2xl bg-volt p-5 transition-colors duration-150 hover:bg-volt-hover" data-id="element-160" data-mp="2rkyc3op2f46u">
            <PlugIcon className="h-6 w-6 text-ink" aria-hidden="true" data-id="element-161" data-mp="31dvzo98wzjcb" />
            <div className="mt-6" data-id="element-162" data-mp="2wlujic8ml8h0">
              <h2 className="text-lg font-bold leading-snug text-ink" data-id="element-163" data-mp="2wkt6i281ubwn">Plug-in batteries</h2>
              <p className="mt-1 text-sm text-ink/75" data-id="element-164" data-mp="3achim5iat0dm">Plug into any socket. No installer, no permit.</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-ink" data-id="element-165" data-mp="35e659ksso7qn">
                From €649
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-166" data-mp="3k9m5k7jywzvh" />
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>;
}